<sourceport-info *ngFor="let sourcePort of sourcePorts" [sourcePort]="sourcePort"></sourceport-info>